import { render } from "./ProjectStat.vue?vue&type=template&id=e7820234&scoped=true"
import script from "./ProjectStat.vue?vue&type=script&lang=js"
export * from "./ProjectStat.vue?vue&type=script&lang=js"

import "./ProjectStat.vue?vue&type=style&index=0&id=e7820234&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7820234"]])

export default __exports__